import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  Path
} from "react-hook-form";

import MailOutlineIcon from "@mui/icons-material/MailOutline";
import TextField from "@mui/material/TextField";

import { EMAIL_REGEX } from "utils/validations.utils";

type EmailFieldProps<T extends FieldValues> = {
  control: Control<T, object>;
  errors: FieldErrors<T>;
  name: Path<T>;
  label: string;
  hideIcon?: boolean;
  fullWidth?: boolean;
  required?: boolean;
};

export default function EmailField<T extends FieldValues>({
  control,
  errors,
  name,
  label,
  fullWidth,
  hideIcon,
  required = false
}: EmailFieldProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: {
          value: required,
          message: `${label} is required`
        },
        pattern: {
          value: EMAIL_REGEX,
          message: `${label} is not valid.`
        }
      }}
      render={({ field, fieldState }) => (
        // @ts-ignore
        <TextField
          id="email-input"
          data-testid="email-field"
          label={label}
          required={required}
          placeholder="Email address"
          type="email"
          {...(Boolean(fieldState.error?.message)
            ? { error: true, helperText: fieldState.error?.message }
            : {})}
          {...field}
          InputProps={
            hideIcon
              ? undefined
              : {
                  startAdornment: <MailOutlineIcon />
                }
          }
          fullWidth={fullWidth}
        />
      )}
    />
  );
}
